import type { OpenOptions } from '../types';
import { buildQueryWithToken } from './build-query';

/** 与 boot 配置同形（这里只需要 baseUrl/tenant/domain/version/source；host 由调用方注入） */
export interface ComposeUrlConfig {
  baseUrl: string;
  tenant?: string;
  domain?: string;
  source?: string;
  version?: string;
}

/**
 * 把 cfg + opts 拼成 /buyer/<id> URL，包含租户/语言/token 等完整 query。
 * `extraCtx` 用于注入额外上下文标识（如小程序场景的 `wx: '1'`）。
 * 零 DOM 依赖。
 */
export function composeBuyerUrl(
  cfg: ComposeUrlConfig,
  opts: OpenOptions,
  idSegment: string,
  host: string,
  extraCtx: Record<string, string> = {},
): string {
  const root = cfg.baseUrl.replace(/\/$/, '');
  const ctxParams: Record<string, string> = {};
  if (cfg.tenant) ctxParams.tenant = cfg.tenant;
  if (cfg.domain) ctxParams.domain = cfg.domain;
  if (cfg.source) ctxParams.source = cfg.source;
  // IOS APP 内嵌客服标识
  ctxParams.ios = 'OPEN_INNER_PAGE';
  Object.assign(ctxParams, extraCtx);

  const ctxQs = Object.entries(ctxParams)
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
  const userQs = buildQueryWithToken(opts, cfg.version ?? '', host);
  const qs = [ctxQs, userQs].filter(Boolean).join('&');
  return `${root}/buyer/${encodeURIComponent(idSegment)}${qs ? '?' + qs : ''}`;
}

/** 不调接口的兜底拼接：用 supplierId 作 idSegment */
export function buildTabUrl(
  cfg: ComposeUrlConfig,
  opts: OpenOptions,
  host: string,
  extraCtx: Record<string, string> = {},
): string {
  return composeBuyerUrl(cfg, opts, String(opts.supplierId ?? 'default'), host, extraCtx);
}
